<template>
  <footer class="footer">
    <notice />
    <!-- 웨이브온 푸터 -->
    <div v-if="isPooqzone && pooqzoneInfo.footerimage" class="footer-company">
      <div class="wrap">
        <a
          :href="pooqzoneInfo.footerlink | url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="getImage(pooqzoneInfo.footerimage)" alt="" />
        </a>
      </div>
    </div>
    <footer-info :isService="isService" />
  </footer>
</template>

<script>
  import FooterInfo from './footer/FooterInfo'
  import Notice from './footer/Notice'
  import { url } from '@/common/filters/url.filter'
  import cookie from '@/common/utils/cookie'
  import { resizeThumbnail } from '@/common/utils/image'

  export default {
    components: {
      FooterInfo,
      Notice,
    },
    filters: {
      url,
    },
    props: {
      isService: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isPooqzone: cookie.isWavveOn(),
        pooqzoneInfo: cookie.getPooqZoneInfo(),
      }
    },
    methods: {
      getImage(img) {
        return resizeThumbnail(img, {
          width: 0,
          height: 0,
          option: 20,
          quality: 80,
        })
      },
    },
  }
</script>
<style scoped>
  .footer {
    min-width: inherit;
  }
  .wrap {
    width: 100%;
    padding: 0 100px;
    position: relative;
  }
</style>
